import { render } from "./Prediction.vue?vue&type=template&id=6c52f205&scoped=true&ts=true"
import script from "./Prediction.vue?vue&type=script&lang=ts"
export * from "./Prediction.vue?vue&type=script&lang=ts"

import "./Prediction.vue?vue&type=style&index=0&id=6c52f205&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c52f205"]])

export default __exports__